import { render, staticRenderFns } from "./MyHealthArea.vue?vue&type=template&id=1d9fa394"
import script from "./MyHealthArea.vue?vue&type=script&lang=js"
export * from "./MyHealthArea.vue?vue&type=script&lang=js"
import style0 from "./MyHealthArea.vue?vue&type=style&index=0&id=1d9fa394&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports